export const environment = {
  production: true,
  version: '3.106.0',
  buildTimestamp: Date.now(),
  enableMsal: false,
  aiEnabled: true,
  // msal config details\
  msalConfig: {
    auth: {
      clientId: '57fdd099-8ce7-41c7-acb5-ba30969dfe9e',
      authority:
        'https://login.microsoftonline.com/108df94a-5373-4e7e-9b3d-2206ddc7ad18',
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false, // Set to true if using IE11 or Edge
    },
  },
  topBarIdentifier: 'top-bar',
};
